import React from 'react';

import { OrganizationSetup } from '~/views/OrganizationSetup/OrganizationSetup';

const NewOrganization = () => <OrganizationSetup creator />;

export default NewOrganization;
